<template>
  <div
    class="login_box"
    :style="`background: url(../img/bg.jpg) no-repeat;`"
  >
    <div class="logo_box">
      <div class="img-box1">
      </div>
      <div class="text">数据大屏</div>
    </div>
    <div class="content">
      <div class="content-left">
        <div class="pic-box">
          <div class="img-box">
          </div>
        </div>
      </div>
      <div class="login">
        <h1>用户登录</h1>
        <el-form
          label-width="0px"
          ref="login"
          :rules="rules"
          :model="loginparam"
        >
          <el-form-item>
            <el-input
              type="text"
              placeholder="请输入用户名"
              v-model="loginparam.uname"
            >
              <template slot="prepend">
                <i class="el-icon-s-custom"></i>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item prop="upass">
            <el-input
              type="text"
              onfocus="this.type='password'"
              autocomplete="new-password"
              placeholder="请输入密码"
              @keyup.enter.native="submitForm()"
              v-model="loginparam.upass"
            >
              <template slot="prepend">
                <i class="el-icon-lock"></i>
              </template>
            </el-input>
          </el-form-item>
          <div class="login_button">
            <el-button type="primary" class="go_login" @click="submitForm()"
              >登录</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from '@/page/system/api/user'
import { cas,baseUrl } from '@/config';
export default {
  name: "Login",
  data() {
    return {
      loginparam: {
        uname: "",
        upass: "",
        code: "",
        uuid: "",
      },
      rules: {
        uname: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        upass: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },

      appUrl: "",
    };
  },
  mounted(){
    if(cas==1){
      let token = this.$route.query.token;
      if(token){
        localStorage.setItem("daping_token", token)
        // sessionStorage.setItem("daping_token",token)
        this.$router.push("/")
      }else{
        window.location.href=baseUrl+"/sso/login"
      }
    }

  },
  methods: {
    submitForm() {
      this.$refs.login.validate((valid) => {
        if (valid) {
          login(this.loginparam).then(resp => {
              if (resp.data.success) {
                localStorage.setItem("daping_token", resp.data.data)
                // sessionStorage.setItem("daping_token",resp.data.data)
                this.$router.push("/");
              }
          });
        } else {
          this.$message.error("请输入账号和密码");
          return false;
        }
      })
    }

  },
};
</script>

<style  lang="scss" scoped>
.login_box {
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: cover !important;
}
.logo_box {
  // width: 411px;
  // height: 70px;
  // width: 20vw;
  height: 8vh;
  position: relative;
  top: 2.4vh;
  left: 3vw;
  display: flex;
  align-items: center;
  .text {
    color: #fff;
    font-weight: bold;
    font-size: 1.6vw;
    margin-left: 0.8vw;
  }
  .img-box1 {
    height: 8vh;
    width: 8vh;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

.content {
  width: 70%;
  // height: 540px;
  height: 60vh;
  overflow: hidden;
  margin: 15vh auto 0;
  display: flex;
  border-radius: 0.5vw;
  align-self: end;
}
.content-left {
  width: 50%;
  // background: #F0F3FF;
  height: 100%;
  text-align: center;
  .pic-box {
    // width: 360px;
    // height: 400px;
    width: 24vw;
    height: 24vw;
    // background: #fff;
    // margin: 10vh auto;
    margin: 10vh 0;
    border-radius: 0.5vw;
    padding-top: 3vw;
    .img-box {
      // width: 260px;
      // height: 260px;
      width: 16vw;
      height: 16vw;
      margin: 0 auto;
      // background: pink;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .tips {
      font-size: 1vw;
      margin-top: 4vw;
    }
  }
}
.login {
  width: 50%;
  text-align: center;
  height: 100%;
  color:#fff;
  background-color: #252830;
  border-radius: 0.5vw;
  // border-top-right-radius: 0.5vw;
  // border-bottom-right-radius: 0.5vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.el-input__inner {
  // width: 430px;
  width: 20vw;
  height: 3vw;
}
.el-form-item {
  margin-bottom: 4vh;
}
h1 {
  margin: 5vw 0 3vw;
  text-align: center;
  font-weight: 400;
  font-size: 1.8vw;
}
.el-form-item__label {
  // line-height: 60px;
  font-size: 1.6vw;
}
.login_button {
  text-align: center;
}
.go_login {
  width: 23.34vw;
  height: 3vw;
  font-size: 1.2vw;
  font-weight: 500;
  letter-spacing: 0.2vw;
  vertical-align: middle;
}
.el-input-group__prepend {
  font-size: 1vw;
}

</style>
